import * as React from "react";
import { Switch } from "react-router-dom";
import ObEqContainer from "../components/toc/orderBook/obContainer/obEquity/obEquityContainer";

import ObEquityConvertDesk from "../components/toc/orderBook/obConvertPositions/obEquityConvertDesk";

import ObNewOffersCont from "../components/toc/orderBook/obContainer/obNewOffers/obNewOffersCont";
import ObCommContainer from "../components/toc/orderBook/obContainer/obCommodity/obCommContainer";
import ObDerContainer from "../components/toc/orderBook/obContainer/obEquity/obDerContainer";
import ObCurContainer from "../components/toc/orderBook/obContainer/obEquity/obCurContainer";
import ObMfContainer from "../components/toc/orderBook/obContainer/obMf/obMfContainer";
import PostLogin from "./postLogin";

const ObRouting = () => {
	return (
		<>
			<Switch>
				<PostLogin path="/convert-position-asset" component={ObEquityConvertDesk} />
				<PostLogin path="/orderbook/eq/:secNav/:pageNav" render={(props) => <ObEqContainer {...props} />} />
				<PostLogin path="/orderbook/derivative/:secNav/:pageNav" render={(props) => <ObDerContainer {...props} />} />
				<PostLogin path="/orderbook/currency/:secNav/:pageNav" render={(props) => <ObCurContainer {...props} />} />
				<PostLogin path="/orderbook/mf/:secNav/:pageNav" render={(props) => <ObMfContainer {...props} />} />
				<PostLogin path="/orderbook/comm/:secNav/:pageNav" render={(props) => <ObCommContainer {...props} />} />
				<PostLogin path="/orderbook/newoffers/:secNav/:inst/:pageNav" render={(props) => <ObNewOffersCont {...props} />} />
			</Switch>
		</>
	);
};
export default ObRouting;
